const index = () => import(/* webpackChunkName: "group-welfare" */ '../view/welfare/index.vue');
const commonWelfare = () => import(/* webpackChunkName: "group-welfare" */ '../view/welfare/commonWelfare.vue');
const myWelfare = () => import(/* webpackChunkName: "group-welfare" */ '../view/welfare/myWelfare.vue');
const welfareFriends = () => import(/* webpackChunkName: "group-welfare" */ '../view/welfare/components/welfareFriends.vue');
const welfareWx = () => import(/* webpackChunkName: "group-welfare" */ '../view/welfare/components/welfareWx.vue');
const welfareWxapp = () => import(/* webpackChunkName: "group-welfare" */ '../view/welfare/components/welfareWxapp.vue');
export default [
    {
        path: '/welfare',
        name: 'welfare',
        component: index,
        meta: {
            title: '【旋涡营销】'
        },
        children: [
            {
                path: '/',
                name: 'commonWelfare',
                component: commonWelfare,
                meta: {
                    title: '【旋涡营销】'
                }
            },
            {
                path: 'myWelfare',
                name: 'myWelfare',
                component: myWelfare,
                meta: {
                    title: '【旋涡营销】'
                }
            },
            {
                path: 'welfareFriends',
                name: 'welfareFriends',
                component: welfareFriends,
                meta: {
                    title: '【旋涡营销】'
                }
            },
            {
                path: 'welfareWx',
                name: 'welfareWx',
                component: welfareWx,
                meta: {
                    title: '【旋涡营销】'
                }
            },
            {
                path: 'welfareWxapp',
                name: 'welfareWxapp',
                component: welfareWxapp,
                meta: {
                    title: '【旋涡营销】'
                }
            }
        ]
    },
]



// WEBPACK FOOTER //
// ./app/router/router-welfare.js